import { render } from "./PackageInformationComponent.vue?vue&type=template&id=132fc8da&scoped=true"
import script from "./PackageInformationComponent.vue?vue&type=script&lang=js"
export * from "./PackageInformationComponent.vue?vue&type=script&lang=js"

import "./PackageInformationComponent.vue?vue&type=style&index=0&id=132fc8da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132fc8da"]])

export default __exports__